export default __webpack_public_path__ + "static/media/noData.eb394c54.svg";